import React, { Component } from 'react';
import session from '../../utils/session';
import urlHandler from '../../utils/urlHandler';

class ExtractArticleQuery extends Component {
    constructor(props){
        super(props);

        this.handleExtract = this.handleExtract.bind(this);
        this.onClear = this.onClear.bind(this);

        this.state = {
            error: null,
            response: null
        };
    }

    handleExtract() {
        var ref = this.refs.url;
        if (ref && ref.value && ref.value.length > 0) {
            var args = `url=${encodeURIComponent(ref.value)}`;
            urlHandler.sendRequest('extract-article', null, args, null, null, (response, arg1, http) => {
                if (http != 200) {
                    var err = '';
                    if ('error_status' in response) { err += `[${response.error_status}] `}
                    if ('error_message' in response) {
                        err += decodeURIComponent(response.error_message);
                    }
                    this.setState({
                        error: err,
                        response: null
                    })
                } else {
                    this.setState({
                        error: null,
                        response
                    })
                }
            });
        }
    }

    onClear() {
        var ref = this.refs.url;
        if (ref) {
            ref.value = '';
            ref.focus();
            this.setState({
                error: null,
                response: null
            })
        }  
    }

    render() {
        return (
            <div>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <span className='form-field-wrapper text-field'>
                        <input type='text'
                            className='form-field-no-box'
                            ref='url'
                            style={{width: '450px'}}
                            placeholder='Enter URL for extraction ...'
                            autoFocus
                        />
                        <button type="button" 
                            className="form-primary-button" 
                            style={{width: '100px', marginLeft: '7px'}} 
                            onClick={this.handleExtract}>Extract Text</button>
                        <button type="button" 
                            className="form-default-button" 
                            style={{width: '100px', marginLeft: '7px'}} 
                            onClick={this.onClear}>Clear</button>
                    </span>
                </div>
                <span style={{color:'indianRed', fontSize: '14px'}}>{this.state.error}</span>
                {(session.isAuthenticated() && this.state.response) &&
                <div className='example-query-wrapper'>
                    <div style={{marginTop: '10px'}}>Response:</div>
                    <div className='example-query-response'>
                        <code id='text'>
                            <pre>{JSON.stringify(this.state.response, null, 3)}</pre>
                        </code>
                    </div>
                </div>
                }
            </div>
        );
    }

}

export default ExtractArticleQuery;